import React from 'react';
import { ShopBuyerCouponsFragmentFragment } from './gql/graphql';

interface ICouponContext {
  coupon: ShopBuyerCouponsFragmentFragment['buyerCoupons'][0];
}

export default React.createContext<ICouponContext>({ coupon: null });
